import { paygEndpoints } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { useAccountContext } from '@ovotech/ui-tools';
import { useQuery } from 'react-query';
import { paygQueryKeys } from './queryKeys';
import { MeterBalance, MeterBalanceResponse } from './types';

type Params = {
  enabled?: boolean;
};

export const useAccountBalances = ({ enabled = true }: Params = {}) => {
  const { accountId } = useAccountContext();

  return useQuery({
    enabled: enabled && !!accountId,
    queryKey: paygQueryKeys.balances(accountId || ''),
    retry: 1,
    queryFn: () =>
      apiService.get<MeterBalanceResponse>({
        url: paygEndpoints.balances(accountId!),
      }),
    select: ({ balances, unavailableBalances }) => ({
      unavailableBalances,
      balances: balances.map(
        (balance): MeterBalance => ({
          balance: balance.balanceInPence / 100,
          msn: balance.msn,
          mpxn: balance.mpxn,
          fuel: balance.fuel,
          date: balance.effectiveAt,
        }),
      ),
    }),
  });
};
